module.exports = "https://www.gc-qa.gnp.com.mx/a497b0be1da633720285613d25979986.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/file.svg
// module id = 1820
// module chunks = 0